// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"d2701b02","156":"fbe8f69c","185":"cde62d07","200":"a9adc7d8","241":"259e4712","347":"b649a29e","565":"ce731964","616":"2d595691","654":"293b3567","768":"f1dce226","930":"cee57990"}[chunkId] + ".chunk.js";
};